export {default} from './Register';



// WEBPACK FOOTER //
// ./src/pages/Register/index.ts